import React from 'react';
import { Gavel } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import MenuBar from '@/components/MenuBar';
import { DebateFeed } from '@/components/social/DebateFeed';
import { DebateScoreboard } from '@/components/social/DebateScoreboard';

const DebatesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <MenuBar />
      
      <main className="flex-1 container mx-auto px-4 py-8">
        <div className="grid gap-6 lg:grid-cols-3">
          {/* Main content - Debate feed */}
          <div className="lg:col-span-2 space-y-6">
            {/* Page header */}
            <div className="text-center space-y-2">
              <div className="flex items-center justify-center space-x-2">
                <Gavel className="h-8 w-8" />
                <h1 className="text-3xl font-bold">deBattle</h1>
              </div>
              <p className="text-muted-foreground">
                {t('debates.feedDescription', 'Se pågående debatter og delta i diskusjonen')}
              </p>
              <p className="text-sm text-muted-foreground">
                {t('debates.rulesShort', '2 debattanter • 3 argumenter hver • Kai kårer vinner')}
              </p>
            </div>

            {/* Debate feed */}
            <DebateFeed />
          </div>

          {/* Sidebar - Scoreboard */}
          <div className="space-y-6">
            <DebateScoreboard limit={10} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default DebatesPage;
